import { o as i } from "../../unsafe-svg-By8nNw37.js";
import { i as c, x as f } from "../../lit-element-6iugfgmM.js";
import { S as d } from "../../Base-pdJ5fkYW.js";
import { e as g } from "../../custom-element-wk-AooBb.js";
const p = c`:host{align-items:center;display:inline-flex;height:32px;--adobe-fonts-logo-size: 32px}svg{width:var(--adobe-fonts-logo-size)}slot{color:var(--spectrum-global-color-gray-900);display:inline-block;font-size:var(--spectrum-alias-font-size-default,var(--spectrum-global-dimension-font-size-100));font-weight:600}slot::slotted(*){margin-left:8px}`;
var m = Object.defineProperty, h = Object.getOwnPropertyDescriptor;
let a = class extends d {
  static get styles() {
    return p;
  }
  render() {
    return f`${i(`<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <defs>
    <style>
      .cls-1 {
        fill: #000b1d;
      }

      .cls-2 {
        fill: #fff;
      }
    </style>
  </defs>
  <g>
    <rect class="cls-1" y="0.5" width="32" height="31" rx="5.64848"/>
    <path class="cls-2" d="M17.63921,13.46488c-.74711,2.504-1.37579,4.91772-2.12289,7.28029a12.90012,12.90012,0,0,1-1.47406,3.41265,4.1921,4.1921,0,0,1-3.31166,1.777c-1.02992,0-2.03957-.48468-2.03957-1.5549A1.40176,1.40176,0,0,1,9.92281,23.0876a.61424.61424,0,0,1,.56539.32311c.50483.90867.98951,1.43364,1.21164,1.43364s.40383-.30284.76725-1.61534l2.65045-9.76247-1.90691-.00211a.91358.91358,0,0,1,.30208-1.03289h1.89816a17.53964,17.53964,0,0,1,1.3978-3.43866,5.04817,5.04817,0,0,1,4.36161-2.928c1.51448,0,2.14044.72695,2.14044,1.65589A1.52543,1.52543,0,0,1,22.01837,9.215c-.323,0-.48456-.24228-.58555-.58555-.34326-1.29235-.78752-1.676-1.05007-1.676s-.66638.48456-1.11052,1.49421a25.74394,25.74394,0,0,0-1.343,3.99058l2.30933-.003a.86867.86867,0,0,1-.31678,1.02946Z"/>
  </g>
</svg>
`)}<slot></slot>`;
  }
};
a = ((l, s, o, t) => {
  for (var n, e = t > 1 ? void 0 : t ? h(s, o) : s, r = l.length - 1; r >= 0; r--) (n = l[r]) && (e = (t ? n(s, o, e) : n(e)) || e);
  return t && e && m(s, o, e), e;
})([g("adobe-fonts-logo")], a);
const w = a;
export {
  w as default
};
//# sourceMappingURL=AdobeFontsLogo.js.map
